import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type UserSettingsEntityTableName = 'user_settings';

export type PreparedUserSettingsData = {
    record: Model;
    table: UserSettingsEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: UserSettingsEntityTableName,
    operation: ValidationOperation,
): PreparedUserSettingsData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedUserSettingsData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
